var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "cardDivTV" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary", fixed: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "", disabled: _vm.btnBloquear },
                      on: {
                        click: function($event) {
                          _vm.dialogConfirmacionClose = true
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _c("v-toolbar-title", [_vm._v(" Editar Solicitud ")]),
                  _c("v-spacer"),
                  _c(
                    "v-toolbar-items",
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-grabar",
                          attrs: {
                            depressed: "",
                            disabled: _vm.solicitudAnulada || !_vm.validForm
                          },
                          on: {
                            click: function($event) {
                              return _vm.grabarEdicion()
                            }
                          }
                        },
                        [_vm._v("Guardar Cambios")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("br"),
              _c("br"),
              _c("br"),
              _c("div", [
                _c(
                  "div",
                  { staticClass: "cardnew", attrs: { align: "center" } },
                  [
                    _c("br"),
                    _c(
                      "v-flex",
                      { attrs: { md10: "" } },
                      [
                        _c(
                          "v-tabs",
                          [
                            _c(
                              "v-tab",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.step = "general"
                                  }
                                }
                              },
                              [_vm._v("Datos Generales")]
                            ),
                            _c(
                              "v-tab",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.step = "solicitud"
                                  }
                                }
                              },
                              [_vm._v("Detalles Solicitud")]
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-card",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.step == "general",
                                expression: "step == 'general'"
                              }
                            ],
                            staticClass: "rounded-card"
                          },
                          [
                            _c("DatosGenerales", {
                              ref: "datosGenerales",
                              attrs: {
                                motivos: _vm.motivos,
                                editedItem: _vm.editedItem,
                                datosActualizados: _vm.datosActualizados,
                                cantEquipos: _vm.cantEquipos,
                                cantPerifericos: _vm.cantPerifericos,
                                cantClientes: _vm.cantClientes
                              },
                              on: {
                                anulado: function($event) {
                                  _vm.solicitudAnulada = $event
                                },
                                valido: function($event) {
                                  _vm.validForm = $event
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "v-card",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.step == "solicitud",
                                expression: "step == 'solicitud'"
                              }
                            ],
                            staticClass: "rounded-card"
                          },
                          [
                            _c("DetalleClientes", {
                              ref: "datosDetallados",
                              attrs: {
                                editedItem: _vm.editedItem,
                                solicitudAnulada: _vm.solicitudAnulada,
                                datosActualizados: _vm.datosActualizados,
                                datostabla: _vm.datostabla,
                                clientes: _vm.clientes
                              },
                              on: {
                                informacion: function($event) {
                                  return _vm.actualizarInformacion($event)
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacionClose,
          titulo: _vm.$t("mensajes.mensajesAbandono.editar.titulo"),
          mensaje: _vm.$t("mensajes.mensajesAbandono.editar.mensaje"),
          textoBtnSi: _vm.$t("mensajes.mensajesAbandono.editar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.mensajesAbandono.editar.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallbackConfirm($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }